// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18901","col":"styles_col__xQ4qe"};